export default "__VITE_ASSET__DkuhPRh5__"